// components/TestimonialSlider.js

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: "Amit Kumar",
    quote: "WashWoosh has made car cleaning so convenient! No more waiting at car wash centers—their doorstep car wash service in Jaipur is quick, efficient, and affordable. The team arrived right at my home in Jagatpura and cleaned my car thoroughly. Highly recommend their quarterly car wash plan with monthly perks like car fresheners and tissue boxes. Great service and eco-friendly too!",
    rating: 5,
  },
  {
    name: "Sanjay Sharma",
    quote: "WashWoosh is a lifesaver! I booked a doorstep car wash in Jagatpura, Jaipur and the service was smooth and quick. As someone who barely has time, this app saved me a lot of hassle. Highly recommend it for working professionals!",
    rating: 5,
  },
  {
    name: "Arpit Goyal",
    quote: "Washwoosh provide car cleaning service at the very minimal prices which are very pocket friendly foe the customers. They provide one day, monthly and other services according to the car categories. I am very happy from their service.",
    rating: 5,
  },
  {
    name: "Ruby Gupta",
    quote: "Been using WashWoosh’s quarterly plan in Sanganer, Jaipur for over 2 months now. Car always looks clean, and the service is consistent. Booking through the app is super easy. Best doorstep car wash service in Jaipur!",
    rating: 5,
  },
  {
    name: "Shankar Meena",
    quote: "I recently used Washwoosh for a doorstep car wash in Jagatpura, Jaipur, and I am absolutely impressed! The app was super easy to use, and I loved how convenient it was to book a car wash at home. The team arrived on time and was very professional. They did a fantastic job with both the interior and exterior of my car, leaving it looking brand new! The eco-friendly products they used were gentle on my car and environment, which I really appreciated. I highly recommend Washwoosh in Jagatpura.",
    rating: 5,
  },
  {
    name: "Ishi",
    quote: "Loved the experience with WashWoosh! The cleaner was polite, on time, and did a great job. Booked from Sanganer and didn’t have to move an inch. Also love the freshener and tissues included in the monthly plan. A must-have for every household!",
    rating: 5,
  }
];

const renderStars = (rating) => {
  const totalStars = 5;
  return [...Array(totalStars)].map((_, i) => (
    <span key={i} style={{ color: i < rating ? "#ffc107" : "#e4e5e9", fontSize: "18px" }}>
      &#9733;
    </span>
  ));
};

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <div className="about-testimonial">
      <div className="container">
        <div className="about-text text-center mb-4" data-aos="fade-up" data-aos-duration={2000}>
          <h2>Customer Reviews</h2>
          <p className="welcome-text"></p>
        </div>

        <Slider {...settings}>
          {testimonials.map((testimonial, idx) => (
            <div key={idx} className="px-3">
              <blockquote className="blockquote border rounded p-4 bg-white">
                <p className="mb-3">“{testimonial.quote}”</p>
                <div className="mb-1">{renderStars(testimonial.rating)}</div>
                <footer className="blockquote-footer mt-1"> {testimonial.name}</footer>
              </blockquote>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialSlider;
